import React from "react";
import { Box } from "@mui/material";
import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";
import { getRouteByPathname } from "../../Handler/RouteHandler";

function AuthenticationLayout(props) {
    const [isSmallView, setSmallView] = React.useState(false);
    const [backgroundPath, setBackgroundPath] = React.useState('');
    const [currentRoute, setCurrentRoute] = React.useState();
    const [fadeKey, setFadeKey] = React.useState(0); 
    const screenReducer = useSelector(state => state.ScreenReducer);
    const location = useLocation();

    React.useEffect(() => {
        setSmallView(screenReducer.screen === "XS" || screenReducer.screen === "SM");
    }, [screenReducer.screen]);

    React.useEffect(() => {
        setCurrentRoute(getRouteByPathname(location.pathname))
    }, [location.pathname]);

    React.useEffect(() => {
        let path = "";
        switch (currentRoute && currentRoute.id) {
            case "authentication_login":
                path = "url(/asset/image/auth-background.webp)";
                break;
            case "authentication_admin":
                path = "url(/asset/image/auth-background2.webp)";
                break;
            case "authentication_register":
                path = "url(/asset/image/auth-background.webp)";
                break;
            case "customer_first_conexion":
                path = "url(/asset/image/auth-background3.webp)";
                break;
            default:
                path = "url(/asset/image/auth-background.webp)";
                break;
        }
        setBackgroundPath(path);
        setFadeKey((prev) => prev + 1); 
    }, [currentRoute]);

    return (
        <Box
            sx={{
                position: "relative",
                minHeight: "100vh",
                width: "100%",
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                overflow: "hidden",
                boxSizing: "border-box",
                p: 2,
            }}
        >
            <Box
                key={fadeKey} 
                sx={{
                    position: "absolute",
                    top: 0,
                    left: 0,
                    width: "100%",
                    height: "100%",
                    backgroundImage: backgroundPath,
                    backgroundSize: "cover",
                    backgroundPosition: isSmallView ? "right" : "center",
                    opacity: 1,
                    animation: "fadeIn 1s cubic-bezier(0.4, 0, 1, 1)", 
                    transitionBehavior: 'allow-discrete',
                    zIndex: -1,
                }}
            />
            <style>
                {`
                @keyframes fadeIn {
                    from {
                        opacity: 0.8;
                    }
                    to {
                        opacity: 1;
                    }
                }
                `}
            </style>

            {/* Content */}
            {props.view && <props.view />}
        </Box>
    );
}

export default AuthenticationLayout;
